import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateFilterReset } from '../../actions/editPolicy-actions';
import store from '../../store';

class Modify extends Component {
    constructor(props) {
        super(props);
    }

    goBack = (e) => {
        if (!(e.target.className === 'filter-back-icon' || (e.target.parentNode && e.target.parentNode.className === 'filter-back-icon') || (e.target.parentNode.parentNode && e.target.parentNode.parentNode.className === 'filter-back-icon') || (e.target.className === 'couponMobile-back-icon' || e.target.parentNode.className === 'couponMobile-back-icon' || e.target.parentNode.parentNode.className === 'couponMobile-back-icon') || (e.target.className === 'otp-back-icon' || e.target.parentNode.className === 'otp-back-icon' || e.target.parentNode.parentNode.className === 'otp-back-icon'))) {
            setTimeout(() => { window.history.back(); }, 100)
        }
    }

    modify = (e) => {
        if (e.target.className === 'Modify') {
            window.location = '/';
            //this.props.history.push('/');
        } else if (e.target.className === 'Reset') {
            store.dispatch(updateFilterReset());
            //this.resetBusType();
            //this.resetAmen();
            //this.resetTime(); 
        }
    }

    render() {
        var React = require("react");
        var Router = require("react-router");
        //var prms = this.props.search.searchParams;

        return (
            <section style={this.modifySection}>
                <div className={this.props.editPolicy.header.text} style={{ display: 'inline-block', position: 'relative', top: '3px' }} onClick={(event) => this.goBack(event)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='20px' fill='#fff'>
                        <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
                    </svg>
                </div>
                <div style={{ display: 'inline-block', position: 'relative', paddingLeft: '15px' }}>
                    <div style={{
                        color: '#FFF',
                        fontWeight: 'bold',
                        fontSize: '15pt'
                    }}>
                        {this.props.editPolicy.header.text1}
                    </div>
                </div>
                <div style={{ 'display': 'inline-block', 'float': 'right' }}>
                    <div className={this.props.editPolicy.header.text2} onClick={(event) => this.modify(event)}>
                        {this.props.editPolicy.header.text2}
                    </div>
                </div>
            </section>
        );
    }

    modifySection = {
        padding: '15px',
        background: window.color['searchBoxBgColor'],
        color: '#fff',
        position: 'fixed',
        width: '100%',
        boxSizing: 'border-box',
        zIndex: '5',
        top: '0',
        left:'0',
        height: '60px',
        display: 'flex'
    }

}

const mapStateToProps = function (store) {
    return (store);
};


export default connect(mapStateToProps)(withRouter(Modify));


// WEBPACK FOOTER //
// ./src/components/modify/modify.js